// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jt-3";
export var downloadButton = "_jt-4";
export var fileContainer = "_jt-9 _jt-7";
export var fileContainerBase = "_jt-7";
export var fileContainerFixedHeight = "_jt-8 _jt-7";
export var fileInfo = "_jt-5";
export var fileInfoWidthRestricted = "_jt-6";
export var fileType = "_jt-1";
export var fileTypeName = "_jt-2";
export var image = "_jt-0";
export var link = "_jt-b";
export var overflowEllipsis = "_jt-a";